import { getUserStatsInfo } from "../../utils/user-stats-info";
import { getCurrentLanguageCode } from "../../utils/configuration";
import { client } from "../client";

export declare interface SendContactFormMessageInput {
	name: string;
	email: string;
	phone: string;
	message: string;
}

export async function sendContactFormMessage(input: SendContactFormMessageInput): Promise<void> {
	const json: any = {
		...input,
		...getUserStatsInfo(),
		languageCode: getCurrentLanguageCode(),
		url: window.document.location.href,
	};

	await client.post("/_api_v0/contact-form-message/send/v1", {
		json,
	});
}
